"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isClientMember = exports.isResolvexMember = void 0;
var gen_types_1 = require("./graphql/gen-types");
var isResolvexMember = function (role) {
    return role === gen_types_1.Roles.ResolvexAdmin || role === gen_types_1.Roles.ResolvexMember;
};
exports.isResolvexMember = isResolvexMember;
var isClientMember = function (role) {
    return (role === gen_types_1.Roles.ClientAdmin ||
        role === gen_types_1.Roles.ClientMember ||
        role === gen_types_1.Roles.ClientSales);
};
exports.isClientMember = isClientMember;
//# sourceMappingURL=permissionHelpers.js.map